<script setup lang="ts">
defineProps({
  show: { type: Boolean },
});
</script>
<template>
  <div class="footer-app">
    <span class="texto" v-if="show">Baixe o App</span>
    <div class="footer-app__content" v-if="show">
      <a href="https://onelink.to/ntybhj" target="_blank">
        <img loading="eager" src="@/assets/img/google_play.png" />
        <img loading="eager" src="@/assets/img/app_store.jpg" />
      </a>
    </div>
  </div>
</template>

<style lang="scss">
.footer-app {
  width: 100%;
  margin: 0.8rem 0;

  span {
    text-align: center;
    display: block;
    margin-bottom: 0.4rem;
  }

  &__content {
    display: flex;
    width: 100%;
    justify-content: center;
    gap: 1rem;

    img {
      max-width: 6rem;
    }
  }
}
</style>
